<div class="centered text-center w-full">

  <img src="assets/images/logo-small.svg" alt="" class="h-32 inline-block align-top" /><br>

  <div class="inline-block text-4xl pt-2">
    <span class="font-medium">SQUADS</span>
  </div>
  <br>
  <span class="iconify splash-spinner mt-5 spin inline-block" data-icon="vaadin:spinner-arc"></span>
</div>
